// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "mova-81a85.firebaseapp.com",
  "projectId": "mova-81a85",
  "storageBucket": "mova-81a85.firebasestorage.app",
  "messagingSenderId": "618138496313",
  "appId": "1:618138496313:web:e38094b62784ac985c8ce8",
  "measurementId": "G-TBV0JY0YST",
  "apiKey": "AIzaSyAQeZuWrJI3pEq-IL77HWHhCYKIBEYRF-0"
};
